function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import path from 'path';
import { useEffect, useState } from 'react';
var breakpoints = [128, 256, 512, 1024, 2048];
var mimeTypes = {
  '.gif': 'image/gif',
  '.png': 'image/png',
  '.jpe': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.webp': 'image/webp',
  '.svg': 'image/svg+xml'
};
export function getImageExtension(url) {
  var sanitizedUrl = url.replace(/\?.*/, '');
  return path.extname(sanitizedUrl).toLowerCase();
}

/**
 * Check if the image that belongs to an url is a valid image.
 *
 * @param {string} url
 */
export function isValidImage(url) {
  if (!url) {
    return false;
  }
  var extension = getImageExtension(url);
  return Object.keys(mimeTypes).includes(extension);
}
export function useImageLoader(initialSrc, targetSrc, imageRef) {
  var _useState = useState(initialSrc),
    _useState2 = _slicedToArray(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInViewport = _useState4[0],
    setIsInViewport = _useState4[1];
  useEffect(function () {
    // @ts-ignore
    if (global.ssr) return;
    if (!imageRef.current) return;
    var image = imageRef.current;
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      if (entry.intersectionRatio > 0) {
        setIsInViewport(true);
      } else {
        setIsInViewport(false);
      }
    }, {
      root: null,
      // 10% of the image must be visible to trigger the callback
      // note that an edge case may occur if the image is so large
      // that even 10% of it exceeds the viewport's height
      threshold: 0.1
    });
    observer.observe(image);

    // eslint-disable-next-line consistent-return
    return function () {
      observer.unobserve(image);
    };
  }, [imageRef, isInViewport, setIsInViewport]);
  useEffect(function () {
    if (initialSrc === targetSrc) return;
    if (!isInViewport) return;
    var img = new Image();
    img.onload = function () {
      return setSrc(targetSrc);
    };
    img.src = targetSrc;
  }, [targetSrc, initialSrc, isInViewport]);
  return src;
}
export function calculateTargetSrc(referenceWidth, sources, fallbackImage) {
  var breakpoint = breakpoints.find(function (bp) {
    return bp >= referenceWidth;
  }) || breakpoints[breakpoints.length - 1];

  // get the index of breakpoint
  var index = breakpoints.indexOf(breakpoint);
  return findClosestIndex(sources, index, fallbackImage);
}

/**
 * Find the item in an array that is closest to the specified index.
 * If the item at the index is not defined, the function will search for
 * the closest item higher than the index, and if not found, it will
 * search for the closest item lower than the index. If no item is found,
 * the fallback value will be returned.
 */
function findClosestIndex(arr, targetIndex, fallback) {
  if (arr.length === 0) return fallback;
  if (arr[targetIndex] !== undefined) return arr[targetIndex];
  var upperIndex = targetIndex + 1;
  var lowerIndex = targetIndex - 1;
  while (upperIndex < arr.length) {
    if (arr[upperIndex] !== undefined) return arr[upperIndex];
    upperIndex += 1;
  }
  while (lowerIndex >= 0) {
    if (arr[lowerIndex] !== undefined) return arr[lowerIndex];
    lowerIndex -= 1;
  }
  return fallback;
}